import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import GameService from '../../../../../services/game.service';
import GamePlayerLogo from './playerLogo';
import PlayerStatDialog from '../../../leaders/status';

const GamePlayerLogoList = ({ game, teamId, opponent, our, setIds, isEdit, t, onChangeTeam }) => {
    const [playerList, setPlayerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectArray, setSelectArray] = useState([]);
    const [statOpen, setStatOpen] = useState(false);
    const [currentPlayer, setCurrentPlayer] = useState(null);

    let statClick = false;

    const handleSelectPlayer = (index) => {
        if (!statClick) {
            setSelectArray({ ...selectArray, [index]: !selectArray[index] });
            statClick = false;
        } else setSelectArray({ ...selectArray, [index]: false });
    };

    const handleDisplayList = (player) => {
        statClick = true;
        const playerTeamId = our ? teamId : opponent;
        const playerWithTeam = { ...player, team_id: playerTeamId };

        // Open dialog directly - let it fetch the data with the correct gameId
        setCurrentPlayer(playerWithTeam);
        setStatOpen(true);
    };

    useEffect(() => {
        setLoading(true);
        setPlayerList([]);

        const currentTeamId = our ? teamId : opponent;
        if (currentTeamId !== -1) {
            GameService.getGameCoachTeamPlayers(currentTeamId, `${game.id}`).then((res) => {
                setPlayerList(res);
                setLoading(false);
                setSelectArray([]);
                res.map((item) => setSelectArray((old) => [...old, false]));
            });
        }
    }, [game, teamId, opponent, our]);

    useEffect(() => {
        const ids = playerList.filter((item, index) => selectArray[index] === true).map((item) => item.player_id);

        setIds(ids);
    }, [selectArray]);

    const selectedCount = Object.values(selectArray).filter(Boolean).length;

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '10px 20px 20px 20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            {/* Team Tabs */}
            {onChangeTeam && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <Box sx={{ display: 'flex', gap: '4px' }}>
                        <Box
                            onClick={() => onChangeTeam(true)}
                            sx={{
                                padding: '6px 16px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                backgroundColor: our ? '#6366f1' : '#f3f4f6',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    backgroundColor: our ? '#6366f1' : '#e5e7eb'
                                }
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: our ? '#ffffff' : '#6b7280'
                                }}
                            >
                                {t('Our Team')}
                            </Typography>
                        </Box>
                        <Box
                            onClick={() => onChangeTeam(false)}
                            sx={{
                                padding: '6px 16px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                backgroundColor: !our ? '#6366f1' : '#f3f4f6',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    backgroundColor: !our ? '#6366f1' : '#e5e7eb'
                                }
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: !our ? '#ffffff' : '#6b7280'
                                }}
                            >
                                {t('Opponent')}
                            </Typography>
                        </Box>
                    </Box>
                    {selectedCount > 0 && (
                        <Typography
                            sx={{
                                fontSize: '10px',
                                fontWeight: 600,
                                color: '#6366f1',
                                backgroundColor: '#f5f3ff',
                                padding: '2px 8px',
                                borderRadius: '4px'
                            }}
                        >
                            {selectedCount} {t('selected')}
                        </Typography>
                    )}
                </Box>
            )}

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70px' }}>
                    <CircularProgress size={24} sx={{ color: '#6366f1' }} />
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        gap: '4px',
                        flexWrap: 'nowrap'
                    }}
                >
                    {playerList.map((item, index) => (
                        <Box
                            key={index}
                            onClick={() => handleSelectPlayer(index)}
                            sx={{
                                flex: '1 1 0',
                                minWidth: 0
                            }}
                        >
                            <GamePlayerLogo
                                player={item}
                                onShow={handleDisplayList}
                                isSelected={selectArray[index]}
                            />
                        </Box>
                    ))}
                </Box>
            )}

            <PlayerStatDialog
                t={t}
                open={statOpen}
                onClose={() => setStatOpen(false)}
                player={currentPlayer}
                games={[game]}
                gameIds={[game.id]}
                isOur={our}
                initialState={null}
                isEdit={isEdit}
            />
        </Box>
    );
};

export default GamePlayerLogoList;
